var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titan-switch",class:_vm.getStyleClass(),on:{"click":function($event){_vm.value = !_vm.value; _vm.validateValue()}}},[(_vm.value !== false)?_c('span',[_vm._v(_vm._s(_vm.t(_vm.yes)))]):_vm._e(),_vm._v(" "),(_vm.value === false)?_c('span',[_vm._v(_vm._s(_vm.t(_vm.no)))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e63a1f02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/Form/Fields/Switch.vue
// module id = null
// module chunks = 